import type { ReactNode } from "react";

/**
 * Таблетка на куті картки: «new», «переглянуто», «beta» (owner 2026-09-25).
 * Одна на всю апку — щоб усі такі мітки були однакові.
 *
 * Текст центруємо по ФАРБІ, а не по рядку (owner 2026-09-25: «слова не ровно
 * посередине таблеток»; на скріні з iPhone NEW сидів на ~0,7px лівіше і
 * ~0,5px нижче центру). Обидві поправки — розміткою, без підгонки пікселів
 * під конкретний рушій: трекінг компенсує лівий відступ, вертикаль — text-box.
 */
export function CornerBadge({
  children,
  tone = "primary",
}: {
  children: ReactNode;
  tone?: "primary" | "muted";
}) {
  return (
    <span
      className={
        // pl більший за pr рівно на трекінг: letter-spacing додає проміжок і
        // після останньої літери, тож без цього слово зсунуте ліворуч.
        "pointer-events-none absolute -right-1.5 -top-1.5 z-10 flex rounded-full " +
        "pl-[calc(0.5rem+0.12em)] pr-2 py-[0.59em] shadow-md " +
        "font-mono text-[0.59375rem] font-bold uppercase leading-none tracking-[0.12em] text-white " +
        (tone === "muted" ? "bg-[#A39B8F]" : "bg-primary")
      }
    >
      {/* text-box обрізає рядок рівно по великих літерах (cap … baseline):
          тоді симетричні py центрують саму фарбу, а не рядок із місцем під
          виносні елементи. Висота таблетки та сама, що й була (~18px). */}
      <span className="corner-badge-ink block [text-box:trim-both_cap_alphabetic]">
        {children}
      </span>
    </span>
  );
}
